import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";

export default function Loader() {
	return (
		<div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}>
			<CircularProgress />
			<Typography variant="body2" color="textSecondary" style={{ marginTop: "16px" }}>
				Loading...
			</Typography>
		</div>
	);
}
